import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-10 text-gray-900 text-base leading-6" style={{
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-162">
      <div className="mx-auto max-w-3xl text-center" data-id="element-163">
        {/* Shield Icon */}
        <div className="mb-4 text-[64px] leading-[64px]" data-id="element-164">🛡️</div>

        {/* Heading */}
        <h2 className="text-3xl font-black leading-10 text-cyan-brand m-0 mb-4" data-id="element-165">
          GARANTÍA PROFEPACK™ — 7 DÍAS
        </h2>

        {/* Guarantee Card */}
        <div className="mb-6 rounded-xl p-6 border-2 border-cyan-brand shadow-sm" style={{
        backgroundColor: 'rgb(240, 249, 255)'
      }} data-id="element-166">
          <p className="text-base leading-[24px] text-gray-900 m-0 mb-3" data-id="element-167">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en la clase si
            querés.
          </p>
          <p className="text-base leading-[24px] text-gray-900 m-0 mb-4" data-id="element-168">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-2xl font-black text-cyan-brand m-0 mb-3" data-id="element-169">
            Te devolvemos el 100%.
          </p>
          <p className="text-lg font-bold text-gray-900 m-0" data-id="element-170">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        {/* Fine Print */}
        <p className="text-xs leading-[20px] text-gray-500 m-0" data-id="element-171">
          La confianza que tenemos en el MegaPack Padel Listo nos permite hacer
          esa promesa sin dudar.
          <br data-id="element-172" />
          Más de 300 profes de pádel de todo el país ya lo saben.
          <br data-id="element-173" />
          La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}